export function parseLaravelErrors<T extends object = {}>(obj: T, queryField: string): Partial<T> {
  return Object.keys(obj)
    .filter(function (key) {
      return key.startsWith(queryField);
    })
    .reduce(function (newData, k) {
      (newData as any)[k] = (obj as any)[k];
      return newData;
    }, {}); //get all validation errors as properties from object related to email validation errors
}
